import Badge from './Badge'

type Props = {
    className?: string
}

export default function ShadowBannedBadge({ className = '' }: Props) {
    return (
        <Badge
            tone="danger"
            shape="rounded"
            size="smallFlush"
            className={className}
            data-tooltip-id="tooltip-id"
            data-tooltip-content="This user is shadow banned"
        >
            Shadow Banned
        </Badge>
    )
}
